<div class="empty-state">
  <div class="title">{{ collectionContent.collections }}</div>
  <div class="sub-title">
    {{ collectionContent.emptyCollectionMessage1 }} <br />
    {{ collectionContent.emptyCollectionMessage2 }}
    <u-button type="link" [label]="collectionContent.learnMore" (onClick)="openLearnMore()"></u-button>
  </div>
  <div class="cards">
    <div *ngFor="let cardInfo of emptyStateCardsContent" class="card" (click)="openNewCollection(cardInfo?.kind)">
      <u-icon class="card-top-image" [model]="{ type: 'img', value: cardInfo?.imageUrl }" [inSvg]="cardInfo?.imageUrl?.lightUrl"></u-icon>
      <div class="card-section">
        <div class="small-title">
          <u-icon
            *ngIf="cardInfo?.icon"
            [model]="{ type: 'font', value: cardInfo?.icon }"
            [styles]="{ fontSize: '16px', marginRight: '8px' }"
          ></u-icon>
          <span>{{ cardInfo?.title }}</span>
        </div>
        <span class="small-sub-title">
          {{ cardInfo?.messageRow1 }} <br />
          {{ cardInfo?.messageRow2 }} <br />
          {{ cardInfo?.messageRow3 }}
        </span>
        <u-button
          class="mx-auto"
          [styleType]="'link'"
          [typeElement]="'primary'"
          [sizeElement]="'extra-small'"
          [versionNumber]="2"
          [label]="'Create New'"
        ></u-button>
      </div>
    </div>
  </div>
</div>
